
const downloadContent = (fileName, content, type) => {
  const blob = new Blob([ content ], { type })

  const url = window.URL.createObjectURL(blob)
  const element = document.createElement('a')
  element.setAttribute('hidden', '')
  element.setAttribute('href', url)
  element.setAttribute('download', fileName)

  document.body.appendChild(element)
  element.click()
  element.remove()
}

export default downloadContent
